import { render } from "./SchemeCard.vue?vue&type=template&id=5b5ad3bc&scoped=true&ts=true"
import script from "./SchemeCard.vue?vue&type=script&lang=ts"
export * from "./SchemeCard.vue?vue&type=script&lang=ts"

import "./SchemeCard.vue?vue&type=style&index=0&id=5b5ad3bc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5ad3bc"]])

export default __exports__